<template>
    <vs-row vs-justify="center" vs-align="center" class="full-height login-register-bg">
        <vs-col type="flex"  vs-justify="center" vs-align="center" class="login-register-box" vs-lg="12" vs-xs="12">
            <vs-card class="mb-0" v-show="!showConfirm">
                <div slot="header">
                    <h3 class="mb-1">Forgot password?</h3>
                    <p class="mb-0">Please fill in your email. На этот адрес будет отправлено письмо с ссылой для ввода нового пароля</p>
                </div>
                <vs-alert v-if="errors.length" class="mb-3 mt-2"  color="danger">
                    <b>Please correct the following error(s):</b>
                    <ul class="common-list">
                        <li v-for="(error, i) in errors" :key="i">{{ error }}</li>
                    </ul>
                </vs-alert>
                <form @submit="checkForm" novalidate="true">
                    <vs-input @keyup="changeLoginData" @change="changeLoginData" icon-after="true" size="large" class="w-100 mb-4 mt-2 vs-input-large" icon="mail" placeholder="Email" v-model="username" type="email"/>
                    <input class="btn-block btn btn-primary submit-button mt-3" @click.stop.prevent="onSubmit" type="submit" value="Reset Password"/>
                </form>
                <div class="d-flex justify-content-center mt-3">
                    <span class="mr-1">Do you have an account?</span><router-link to="/site/login"> Login</router-link>
                </div>
            </vs-card>

            <vs-card v-show="showConfirm" class="mb-0">
                <div slot="header">
                    <h3 class="mb-1">Введите проверочный код</h3>
                    <p class="mb-1">Для сброса пароля введите код, пришедший вам в email</p>
                </div>
                <form @submit="checkConfirm" novalidate="true">
                    <vs-input icon-after="true" size="large" class="w-100 mb-4 mt-2 vs-input-large" icon="mail" placeholder="Verification code" v-model.trim="activationCode" type="text"/>
                    <input class="btn-block btn btn-primary submit-button mt-3" @click.stop.prevent="onConfirm" type="submit" value="Check code"/>
                </form>

                <div class="d-flex justify-content-center mt-3">
                    <span class="mr-1">Do you have an account?</span><router-link to="/site/login"> Login</router-link>
                </div>
            </vs-card>
        </vs-col>
    </vs-row>
</template>

<script>
    import {AuthService} from "../../services/auth.service";
    import Nprogress from 'nprogress';

    export default {
        name: 'ResetPassword',
        data:()=>({
            errors:[],
            username: '',
            showConfirm: false,
            activationCode:''
        }),
        methods:{
            checkForm:function(e) {
                this.errors = [];
                if(!this.username) {
                    this.errors.push("Email required.");
                } else if(!this.validEmail(this.username)) {
                    this.errors.push("Valid email required.");
                }
                if(!this.errors.length) return true;
                e.preventDefault();
            },


            /* eslint-disable */
            validEmail:function(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            /* eslint-enable */

            changeLoginData: function(e){
              if (e.key !== 'Enter') {
                this.errors = [];
              }
            },

            onSubmit: function(e){
                if (this.checkForm(e)) {
                    Nprogress.start();
                    AuthService.makeReset(this.username)
                        .then(response => {
                            Nprogress.done();
                            if(response.status){
                                this.showConfirm = true;
                            } else {
                                this.showConfirm = false;
                                this.errors.push(response.message);
                            }
                        })
                        .catch(error => {
                            Nprogress.done();
                            this.errors = error.apply();
                        });
                } else {
                    e.preventDefault();
                }
            },

            checkConfirm: function(e){
                if (this.activationCode) {
                    return true;
                }
                e.preventDefault();
                return false;
            },

            onConfirm: function (e) {
                if (this.checkConfirm(e)) {
                    this.$router.push({name: 'changepassword', params:{
                            token: this.activationCode
                        }});
                } else {
                    e.preventDefault();
                }
            }
        }
    }
</script>

<style>
    .login-register-bg{
        margin:0 auto;
        background:url(../../assets/images/background/auth-bg.jpg) no-repeat center center;
    }
    .login-register-box{
        max-width:400px;
    }

</style>
